import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/icon'
import { Button } from '@/components/ui'
import { AtendimentoDropdownMenuChile } from '@/features/atendimento/chile/components/atendimento-dropdown-chile'
import { useAtendimento } from '@/hooks/use-atendimento'
import { useCountryNavigate } from '@/hooks/use-localized-navigate'

export const AtendimentoTriggerChile = () => {
  const { t } = useTranslation('atendimento')
  const navigate = useCountryNavigate()
  const { atendimento } = useAtendimento()

  if (atendimento?.id) return <AtendimentoDropdownMenuChile nome={atendimento.cliente.nome} />

  return (
    <Button
      variant="secondary"
      className="font-nunito shadow-cz bg-white font-semibold text-neutral-700"
      onClick={() => navigate('/atendimento/iniciar')}
    >
      <>
        <Icon name="square-play" className="text-neutral-400" size={20} />
        {t('iniciar_atendimento')}
      </>
    </Button>
  )
}
